












import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class Tooltip extends Vue {
    @Prop({required: false, default: () => false}) private readonly top!: boolean;
    @Prop({required: false, default: () => false}) private readonly bottom!: boolean;
    @Prop({required: false, default: () => false}) private readonly left!: boolean;
    @Prop({required: false, default: () => false}) private readonly right!: boolean;
}

